import Glide from '@glidejs/glide';
import initLCP from '../../components/LCP';
import Tabs from '../../components/Tabs';

import './style.scss';

const initLCPSlider = () => {
  const glide = new Glide('[data-slider="lcp"]', {
    perView: 3,
    gap: 24,
    type: 'carousel',
    focusAt: 'center',
    breakpoints: {
      1023: {
        perView: 2,
      },
      767: {
        gap: 0,
        perView: 1,
      },
    },
  });

  glide.mount();
};

const initSamplesSlider = () => {
  const glide = new Glide('[data-slider="samples"]', {
    perView: 3,
    gap: 24,
    type: 'carousel',
    focusAt: 'center',
    breakpoints: {
      1023: {
        perView: 2,
      },
      767: {
        gap: 0,
        perView: 1,
      },
    },
  });

  const samplesBlock = document.querySelector('[data-slider="samples"]');
  const samplesCarts = Array.prototype.slice.call(samplesBlock.querySelectorAll('.card'));

  samplesCarts.forEach((order, key) => {
    const bullet = document.createElement('button');
    bullet.classList.add('glide__bullet');
    bullet.setAttribute('data-glide-dir', `=${key}`);
    document.querySelector('[data-bullets="samples"]').appendChild(bullet);
  });

  glide.mount();
};

const initTabs = () => {
  const tabsContainer = document.querySelector('.tabs-container');
  if (tabsContainer) {
    const tabs = new Tabs({
      container: tabsContainer,
      index: 0,
    });
    tabs.init();
  }
};

__WMS__.utils.observeElement({
  element: '.section-samples-lcp',
  marginValue: 200,
  callback: () => {
    initSamplesSlider();
    initLCP(initLCPSlider);
    initTabs();
  },
});
